/**
 * PAYPAL ERROR FIX - LICENSE GLOBAL
 * Risolve gli errori di comunicazione del PayPal SDK
 */

document.addEventListener('DOMContentLoaded', function() {
  // Applica il fix solo se non è già stato applicato
  if (window.paypalErrorFixApplied) return;
  
  // Cache delle funzioni originali
  const originalMethods = {
    consoleError: console.error,
    postMessage: window.postMessage
  };

  // Pattern regex per errori PayPal
  const paypalErrorPatterns = [
    /paypal_js_sdk_v5_unhandled_exception/i,
    /no ack for postmessage/i,
    /paypal/i
  ];

  // Funzione per verificare se un errore è correlato a PayPal
  function isPaypalError(message) {
    const errorString = typeof message === 'string' ? message : String(message);
    return paypalErrorPatterns.some(pattern => pattern.test(errorString));
  }

  // Funzione per gestire gli errori di PayPal
  function handlePaypalErrors() {
    // Intercetta e gestisce gli errori non gestiti di PayPal
    window.addEventListener('error', function(event) {
      if (event.message && isPaypalError(event.message)) {
        console.warn('PayPal SDK error intercepted and handled:', event.message);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }, true);
    
    // Intercetta gli errori non gestiti specifici di PayPal
    window.addEventListener('unhandledrejection', function(event) {
      if (event.reason && typeof event.reason === 'string' && isPaypalError(event.reason)) {
        console.warn('PayPal SDK promise rejection intercepted:', event.reason);
        event.preventDefault();
        return false;
      }
    });
    
    // Sovrascrive console.error per filtrare gli errori di PayPal
    console.error = function(...args) {
      const errorString = args.join(' ');
      if (isPaypalError(errorString)) {
        console.warn('PayPal SDK filtered:', ...args);
        return;
      }
      return originalMethods.consoleError.apply(console, args);
    };
    
    // Aggiunge un handler per i messaggi postMessage non gestiti
    window.postMessage = function(message, targetOrigin, transfer) {
      try {
        return originalMethods.postMessage.call(this, message, targetOrigin, transfer);
      } catch (error) {
        if (error.message && isPaypalError(error.message)) {
          console.warn('PayPal postMessage error handled:', error.message);
          return;
        }
        throw error;
      }
    };
  }
  
  // Applica il fix
  handlePaypalErrors();
  window.paypalErrorFixApplied = true;
});